import React from 'react';
import { Icon } from 'ui';
import CoverImage from 'components/Learn/shared/CardCoverImage';
import EstimatedDuration from 'components/Learn/shared/LearnContentCard/EstimatedDuration';
import FeatureFlag from 'components/shared/FeatureFlag';
import ActionButton from '../Content/ActionButton';
import { withStatusModifier } from '../helpers.js';
import StepNumber from '../Content/Step';
import ContentStatus from '../Content/Status';

const Step = ({
  id,
  progress,
  status,
  formattedStatus,
  title,
  stepNumber,
  description,
  dueDate,
  isOverdue,
  required,
  dateAdded,
  type,
  urls,
  image,
  estimatedMinutesToComplete,
}) => (
  <div className={withStatusModifier('PathContentSubStep', status)}>
    <FeatureFlag features="lesson_card_image_enhancements_in_paths">
      {image && (
        <CoverImage image={image} className="PathContentSubStep-image" />
      )}
    </FeatureFlag>
    <div className="d-f w-fill">
      <div className="PathContentSubStep-container">
        <div className="PathContentSubStep-header jc-sb">
          <div className="PathContentSubStep-title ai-c">
            <Icon name="lesson" className="PathContentSubStep-icon f-sh-0" />
            <span className="PathContentSubStep-title f-smooth mr-8">
              {title}
            </span>
            {estimatedMinutesToComplete && (
              <EstimatedDuration
                estimatedMinutesToComplete={estimatedMinutesToComplete}
              />
            )}
          </div>
          <ContentStatus
            {...{
              progress,
              status,
              formattedStatus,
              dueDate,
              isOverdue,
              urls,
              required,
              dateAdded,
            }}
          />
        </div>
        {!!description && (
          <div className="PathContentSubStep-description f-smooth">
            {description}
          </div>
        )}
        {!status.match(/upcoming|locked/i) && (
          <ActionButton
            {...{ status, type, urls }}
            className="PathContentSubStep-button"
            small
          />
        )}
      </div>
    </div>
    {stepNumber && <StepNumber {...{ progress, stepNumber, id }} inner />}
  </div>
);

export default Step;
